import { Form } from 'antd'
import { useStoreActions, useStoreState } from 'easy-peasy'
import { useEffect } from 'react'
import { errorMessage, successMessage } from 'components/BannerComponent'
import { GENERIC_FAIL_MESSAGE } from 'utils/constants'

export default function Container ({ children }) {
  const [form] = Form.useForm()

  const state = useStoreState(s => ({
    contactUsState: s.contactUsState
  }))

  const actions = useStoreActions(a => ({
    contactUs: a.contactUs,
    setContactUsState: a.setContactUsState
  }))

  const handleContactUs = (values) => {
    const data = {
      name: values.first_name + ' ' + values.last_name,
      subject: values.subject,
      message: values.message,
      email: values.email
    }

    actions.contactUs(data)
  }

  useEffect(() => {
    const { status, payload } = state.contactUsState
    if (status === 2) {
      successMessage('Email sent successfully.')
      actions.setContactUsState({ status: 0, payload: null })
      form.resetFields()
    } else if (status === 3) {
      const errorMsg = Object.values(objectErrors(payload)).map((val) => val)
      errorMessage(errorMsg.join(', '))
      actions.setContactUsState({ status: 0, payload: null })
    }
  }, [state.contactUsState])

  return children({ form, handleContactUs, state })
}
